var React = require('react');

function CartInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"cart.inline"),React.createElement("g",{"id":"b98e978e-b15e-47ab-b26f-54b69c3514bd","data-name":"Layer 2","key":1},React.createElement("g",{"id":"b36550af-7564-44fb-98c2-7c25486225d4","data-name":"Layer 1"},React.createElement("g",{"id":"a954b562-9f6f-41c9-9367-8b1e3e1000bc","data-name":"cart.inline"},React.createElement("path",{"d":"M26.68,30h-21L.81,15.39H30m8.1-9.72H32.4L25.92,33.21H8.1m20.25,2.43a2.43,2.43,0,1,1-2.43-2.43A2.43,2.43,0,0,1,28.35,35.64Zm-17.82,0A2.43,2.43,0,1,1,8.1,33.21,2.43,2.43,0,0,1,10.53,35.64ZM21.87,7.29,17,12.15,12.15,7.29M17,.81V12.15","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.62"}))))]);
}

CartInline.defaultProps = {"viewBox":"0 0 38.88 38.88"};

module.exports = CartInline;

CartInline.default = CartInline;
